module.exports = __webpack_public_path__ + "img/cuarto menguante.1e1c338b.png";